import React, { useState, useEffect } from 'react';

import i18n from '@components/i18n/i18n';
import { useMessageBanner } from '@hooks';
import styles from './MessageBanner.module.scss';

const MessageBanner = () => {
  const dir = i18n.dir();
  const [visibility, setVisibility] = useState(false);
  const {
    field_title,
    field_description,
    field_cta,
    field_open_in_new_tab_,
    field_visible_,
  } = useMessageBanner();
  const missing = !(field_title || field_description || field_cta);

  // helpers
  const windowExists = () => (typeof window !== `undefined` ? true : false);
  const cleanUrl = a => a.replace('internal:', '').replace('external:', '');
  const urlContains = a =>
    a.some(b => window.location.pathname.indexOf(b) >= 0);

  const exceptions = [
    '/air/reserve',
    '/air/configure',
    '/portal',
    cleanUrl(field_cta.uri),
  ];

  useEffect(() => {
    setVisibility(visibility => true);
    return () => {
      setVisibility(visibility => false);
    };
  }, []);

  // if visibility state == false, return nothing
  if (visibility == false) return false;
  //
  // if visibility field == false, return nothing
  if (field_visible_ == false) return false;
  //
  // if all fields are blank, return nothing
  if (missing) return false;
  //
  // if current page is an exception, return nothing
  if (windowExists() && urlContains(exceptions)) return false;
  //
  // otherwise, return banner
  return (
    <div className={[styles.MessageBanner, styles[dir]].join(' ')}>
      <p>
        {field_title && <span className={styles.title}>{field_title}</span>}
        {field_description && (
          <span className={styles.description}>{field_description}</span>
        )}
        {field_cta && (
          <a
            className={styles.cta}
            href={cleanUrl(field_cta.uri)}
            target={field_open_in_new_tab_ ? '_blank' : '_self'}
            rel="noreferrer"
          >
            {field_cta.title}
          </a>
        )}
      </p>
    </div>
  );
};

export default MessageBanner;
